const responseState = {
  data: [],
  loading: false,
  error: null,
};

const aiSummarizerInitialState = {
  contentAISummary: {
    instagram: responseState,
    news: responseState,
    newspaper: responseState,
    telegram: responseState,
    twitter: responseState,
    virasty: responseState,
    nativePlatforms: responseState,
    modal: responseState,
    limitedRequestCount: 0,
  },
  contentAISummaryArchives: {
    data: {},
    loading: false,
    error: null,
  },
};

export default aiSummarizerInitialState;
